import { render, staticRenderFns } from "./veStuReward.vue?vue&type=template&id=d775403a&scoped=true"
import script from "./veStuReward.vue?vue&type=script&lang=js"
export * from "./veStuReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d775403a",
  null
  
)

export default component.exports